<template>
    <div class="topFixedWrap" id="topFixedWrap">
        <!-- 一级导航 -->
        <nav class="nav">
            <router-link :to="item" v-for="(item,index) in navMap" :key='index'>
                <span class="selected" v-if="navSelected == index"></span>{{index}}
            </router-link>

            <AppToolbar/>
        </nav>
        <!-- 二级导航 -->
        <nav class="newsSubTit">
            <div class="newTit" id="scroll">
                <a
                  v-for="(item,index) in subtitleData"
                  :class="{'subTitSelected':getSubtitChoose==item.label,'pad':pad}"
                  :href="`/${getUrlTitle(navMap[navSelected])}/${getUrlTitle(item.label)}`"
                  :key="index"
                  @click.prevent="subTitToggle(item,index)"
                >
                  {{item.label}}
               </a>
            </div>
        </nav>

        <!-- 三级导航 -->
        <nav v-if='isThirdTit' class="nav thirdTitwrap" >
            <div class="thirdTit">
                <a
                   v-for="(item,index) in thirdTotalTitle"
                   :class="{'thirdTitSelected':getThirdTitChoose === item.title, 'thirdTitWidth': thirdTotalTitle.length < 4}"
                   :key="index"
                   @click.prevent="thirdTitleToggle(item,index)"
                >
                   {{item.title}}
                </a>
            </div>
        </nav>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar.vue'

export default {
    name: 'navVue',
    components: {
        AppToolbar
    },

    props: [
        'subtitleData',
        'navSelected',
        'isThirdTit',
        'pad',
        'loadingShowProp'
    ],

    data() {
        return {
            thirdTotalTitle: [],
            navMap: {
                'BERITA': '/news',
                'COCOK': '/matchs',
                'VIDEO': '/video',
                'STATISTIK': '/stats'
            },
            currentListData: [], // 当前选中tab下的所有数据
            loading: false,
            subNavTranslateX: function () { },
            googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end',
        }
    },

    computed: {
        ...mapGetters([
            'getSubtitChoose',
            'getThirdTitChoose'
        ]),
        statsSubTabList() {
            return this.$store.state.navStore.statsSubTabList
        }
    },

    created() {
        if (this.navSelected !== 'STATISTIK') return

        const statsSubTabList = this.statsSubTabList
        const getSubtitChoose = this.getSubtitChoose

        if (statsSubTabList.length) {
            const selectedSubtab = statsSubTabList.find(sub => sub.label === getSubtitChoose)

            if (selectedSubtab) {
                this.thirdTotalTitle = selectedSubtab.urlApi
            } else if (!getSubtitChoose) {
                this.thirdTotalTitle = statsSubTabList[0].urlApi
            }
        }

        this.$store.commit('setThirdTitChoose', (this.thirdTotalTitle.length && this.thirdTotalTitle[0].title) || 'Tabel')
    },

    mounted() {
        this.subNavTranslateX = function (index) {
            // 二级导航点击移动效果
            const scrollBar = document.getElementById('scroll')
            const scrollBarTab = scrollBar.querySelectorAll('a')
            const screenWidth = document.documentElement.clientWidth // 屏幕宽度

            // 计算滚动条的滚动距离
            this.scrollLeft = scrollBar.scrollLeft
            // 计算当前a标签距离屏幕左边的距离
            this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left
            // 计算当前a标签距离屏幕右边的距离
            this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width)
            // 计算平均距离
            const average = (this.leftToScreen + this.rightToScreen) / 2
            // 如果左边距离小于右边距离，则滚动条向左滚动
            if (this.leftToScreen < this.rightToScreen) {
                scrollBar.scrollLeft -= (average - this.leftToScreen)
            } else {
                scrollBar.scrollLeft += (average - this.rightToScreen)
            }
        }
    },

    methods: {
        subTitToggle(item, index) {
            if (this.loadingShowProp) return
            if (this.getSubtitChoose === item.label) return

            // 空格 转成 -
            const subTitle = this.getUrlTitle(item.label)

            if (this.$route.params.subtitle) {
                history.replaceState(null, null, `./${subTitle}`)
            } else {
                history.replaceState(null, null, `${this.$route.path}/${subTitle}`)
            }

            this.subNavTranslateX(index)
            this.scrollFn(item.label)

            // 只有两级导航时
            if (!this.isThirdTit) {
                this.subNavTranslateX(index)
                this.scrollFn(item.label)
                // 获取点击二级导航后对数据
                this.$store.commit('setSubtitChoose', item.label)
                // 原来是回调Apphome的方法回调列表数据
                const urlApi = item.urlApi

                if (this.navSelected === 'BERITA') {
                    this.$store.dispatch('newsListApi', { urlApi })
                } else if (this.navSelected === 'COCOK') {
                    this.$store.dispatch('matchListApi', { urlApi })
                } else if (this.navSelected === 'VIDEO') {
                    this.$store.dispatch('videoListApi', { urlApi, type: 1 })
                }
            } else {
                // 有三级导航时
                if (this.navSelected === 'STATISTIK') {
                    const urlApi = (item.urlApi && item.urlApi[0].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')) || ''

                    if (this.statsSubTabList.length && item.label) {
                        const res = this.statsSubTabList.find(elem => elem.label === item.label)
                        this.thirdTotalTitle = res.urlApi ? res.urlApi : this.thirdTotalTitle
                    }

                    this.$store.commit('setSubtitChoose', item.label)
                    this.$store.commit('setThirdTitChoose', 'Tabel')
                    this.$store.dispatch('statsListApi', { urlApi, thirdTitChoose: 'Tabel' })
                }
            }
        },

        thirdTitleToggle(elem) {
            if (this.loadingShowProp) return
            if (this.getThirdTitChoose === elem.title) return

            this.$store.commit('setThirdTitChoose', elem.title)
            this.scrollFn(this.getSubtitChoose)

            if (this.navSelected === 'STATISTIK') {
                const urlApi = (elem.url && elem.url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '')) || ''
                this.$store.dispatch('statsListApi', { urlApi, thirdTitChoose: elem.title })
            }
        },

        scrollFn() {
            window.browers = {}
            let ua = navigator.userAgent.toLowerCase()
            browers.Android = ua.match(/android/)
            browers.iOS = ua.match(/ipad|iphone|ios/)

            const headHeight = 0// 下载条高度
            const topFixedWrap = document.getElementById('topFixedWrap')
            const contentWrap = document.getElementById('contentWrap')// 每个二级导航下的列表内容

            if (document.body.scrollTop || document.documentElement.scrollTop >= headHeight) {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed'
                    setTimeout(function () {
                        topFixedWrap.className = 'topFixedWrap'
                    }, 10)
                    contentWrap.style.paddingTop = 0 + 'px'
                    console.log(contentWrap.style.paddingTop)
                } else if (browers.iOS) {
                    topFixedWrap.className = 'topFixedWrap'
                    contentWrap.style.paddingTop = 0 + 'px'
                }

                // 滚动到吸顶位置
                setTimeout(function () {
                    console.log('**滚了 ', headHeight)
                    document.body.scrollTop = headHeight
                    document.documentElement.scrollTop = headHeight
                }, 10)
                console.log('document.body.scrollTop:' + document.body.scrollTop)
            } else {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap'
                    contentWrap.style.paddingTop = 0 + 'px'
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  height: 2.4rem;
  background: #16b13a;
  line-height: 2.4rem;
  overflow: hidden;
}

.nav a {
    flex-shrink: 0;
    flex: 1;
    text-align: center;
    color: #fff;
    font-size: .75rem;
    float: left;
    text-decoration: none !important;
    position: relative;
    height: 1.4rem;
    line-height: 1.4rem;
    padding: .5rem 0;
    overflow: hidden;
    font-weight: bold;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:last-of-type {
        flex-grow: 1.3;
    }
}

    .selected {
        display: inline-block;
        width: .5rem;
        height: .4rem;
        line-height: 1.2rem;
        background: url("../assets/home/home_arrow.png") no-repeat;
        background-size: 100% auto;
        position: absolute;
        bottom: -.1rem;
        left: 50%;
        margin-left: -.2rem;
        z-index: 10;
    }

    .newsSubTit {
        height: 2.2rem;
        width: 100%;
        font-size: 0.68rem;
        line-height: 2.5rem;
        text-align: center;
        color: #2d2f32;
        border-bottom: 0.01rem solid #eff1f4;
        background: #fff;
    }

    .newsSubTit > div {
        top: 0;
        overflow-x: scroll;
        white-space: nowrap;
        padding: 0 .8rem;
        position: relative;

        &::-webkit-scrollbar {
          display: none;
        }
    }

    .newsSubTit a {
        display: inline-block;
        padding: 0 .7rem;
        position: relative;
        height: 1.1rem;
        line-height: 1.1rem;
        padding: .3rem .7rem;
        color: #2d2f32;
        font-size: .9rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .subTitSelected {
        color: #16b13a !important;
        border-bottom: .15rem solid #16b13a;
    }

    /*stat 三级导航*/
    .thirdTitwrap {
        height: 3.2rem;
        background: #333d46;
        overflow: hidden;
        color: #929cad;
    }

    .thirdTit {
        height: 1.5rem;
        width: 94%;
        margin: .8rem auto;
        line-height: 1.5rem;
        border: 1px solid #1d2328;
        border-radius: 0.01rem;
    }

    .thirdTit a {
        width: 25%;
        color: #929cad;
        /*display: inline-block;*/
        float: left;
        text-align: center;
        border-right: 1px solid #1d2328;
        text-decoration: none;
        box-sizing: border-box;
        height: 1.5rem;
        line-height: 1.5rem;
        font-size: .8rem;
        padding: 0;
    }
    .thirdTitWidth {
        width: 33.3% !important;
    }
    .thirdTit > a.thirdTitSelected {
        background: #1d2328 !important;
        color: #fff !important;
    }

    .thirdTit > a:last-of-type {
        border-right: none;
    }

    /*定位*/
    .topFixedWrap {
        width: 100%;
        z-index: 100;
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0rem;
    }

    //Android
    .main > .tab-box-fixed {
        position: fixed !important;
        z-index: 10;
        top: 0;
        left: 0;
    }

    .main > .tab-box-testFix {
        z-index: 10;
        top: 0;
        left: 0;
    }

    //iOS
    .tab-box-sticky {
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .pad {
        margin: 0 3rem;
    }
</style>



// WEBPACK FOOTER //
// navNew.vue?513cd30c